const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim() ?? "";
const scriptId = "ga4-gtag";

let initialized = false;
let lastTrackedPath = "";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function isEnabled() {
  return typeof window !== "undefined" && measurementId.length > 0;
}

function ensureGoogleTag() {
  if (document.getElementById(scriptId)) {
    return;
  }

  const script = document.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export function initializeAnalytics() {
  if (!isEnabled()) {
    return false;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (!window.gtag) {
    window.gtag = (...args: unknown[]) => {
      window.dataLayer.push(args);
    };
  }

  ensureGoogleTag();

  if (!initialized) {
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { send_page_view: false });
    initialized = true;
  }

  return true;
}

export function trackPageView(pagePath: string) {
  if (!initializeAnalytics()) {
    return false;
  }

  if (pagePath === lastTrackedPath) {
    return false;
  }

  lastTrackedPath = pagePath;
  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });

  return true;
}
